import type { ConfigResponse } from './api/embed';
import { useConfig } from './state/vocab';

/** Newer widget features, each with two kill switches:
 *  - build: VITE_WIDGET_DISABLED_FEATURES=next_skin,bulk_upsell
 *  - runtime: WIDGET_DISABLED_FEATURES on the API, which /embed/v1/config
 *    reports as `features: { name: false }`.
 *  A feature is on unless either switch turns it off. */
export type WidgetFeature = 'next_skin' | 'bulk_discount_strip' | 'bulk_upsell';

const BUILD_OFF = new Set(
  (import.meta.env.VITE_WIDGET_DISABLED_FEATURES ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean),
);

export function featureOn(config: ConfigResponse | null | undefined, name: WidgetFeature): boolean {
  return !BUILD_OFF.has(name) && config?.features?.[name] !== false;
}

export function useFeature(name: WidgetFeature): boolean {
  return featureOn(useConfig(), name);
}
